import SalesChannelDetailsForm from '../Forms/SalesChannelDetailsForm';

const PikForm = () => <SalesChannelDetailsForm showToken={false} showWarehouse={false} showOrderPrefix={false} />;

export default PikForm;
